<template>
  <ListModule
    @click="click"
    @more="more"
    :index="index"
    :config="config"
    :data="dataFixed"
    :isEditMode="isEditMode"
    class="module-case"
  >
  </ListModule>
</template>

<script>
import _ from 'lodash'
import ListModule from './ListModule.vue'
export default {
  components: {
    ListModule
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    config: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dataFixed () {
      let list = _.get(this.data, 'value', [])
      let value = _.reduce(list, (accumulator, currentValue, i) => {
        // if (i !== 0) {
        //   accumulator.push({
        //     type: 'line'
        //   })
        // }
        currentValue.index = i + 1
        accumulator.push(currentValue)
        return accumulator
      }, [])

      return {
        id: this.data.id,
        type: this.data.type,
        name: this.data.name,
        // moreText: '查看更多',
        value
      }
    }
  },
  methods: {
    click () { this.$emit('click') },
    more () { this.$emit('more') }
  }
}
</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/containers/module/CaseModule.vue